import React from 'react';
import "../styles/Hostel.css"; // Importing custom CSS for the page

const hostelFacilities = [
  {
    name: "Mayalawas Gurukul Hostel",
    description:
      "Our Mayalawas Gurukul offers comfortable and well-equipped hostels for students. With spacious rooms, proper sanitation, and excellent facilities, it ensures a homely environment for students to focus on their studies.",
    facilities: [
      "Spacious Rooms",
      "Clean & Hygienic Washrooms",
      "Gated Security",
      "Mess with Healthy Meals",
      "Recreational Room",
      "Sports Facilities",
    ],
    images: [
      "/mayalawas.jpg",
      "/mayalawas1.jpg",
    ],
    video: "/mayalawasF.mp4",
  },
  {
    name: "Bijrol Kheda Gurukul Hostel",
    description:
      "Bijrol Kheda Gurukul provides state-of-the-art hostel facilities designed to cater to the needs of students. The hostel is fully equipped with all the amenities needed to ensure the comfort and safety of our students.",
    facilities: [
      "Fully Furnished Rooms",
      "Modern Kitchen & Mess",
      "Recreation Area",
      "Yoga & Meditation Hall",
      "Sports Ground",
    ],
    images: [
      "/kheda.jpg",
      "/kheda1.jpg",
    ],
    video: "/mayalawasF.mp4",
  },
];

const Hostel = () => {
  return (
    <div className="hostel">
      {/* Header Section */}
      <div className="hostel-header">
        <h1 className="hostel-title">Our Hostel Facilities</h1>
        <p className="hostel-subtitle">Comfort, Safety, and Wellness</p>
      </div>

      {/* Hostel Cards Section */}
      <div className="hostel-container">
        {hostelFacilities.map((hostel, index) => (
          <div className="hostel-card" key={index}>
            <div className="hostel-header-img">
              <img src={hostel.images[0]} alt={hostel.name} className="hostel-header-img" />
            </div>
            <h2 className="hostel-name">{hostel.name}</h2>
            <p className="hostel-description">{hostel.description}</p>

            <div className="hostel-facilities">
              <h3>Facilities Offered:</h3>
              <ul>
                {hostel.facilities.map((facility, idx) => (
                  <li key={idx}>{facility}</li>
                ))}
              </ul>
            </div>

            {/* Video Section - Simple Video Embed */}
            <div className="hostel-media">
              <video className="hostel-video" controls>
                <source src={hostel.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* Gallery Section */}
            <div className="hostel-gallery">
              <h3>Gallery:</h3>
              <div className="gallery-grid">
                {hostel.images.map((image, idx) => (
                  <img key={idx} src={image} alt={`Hostel ${idx + 1}`} className="gallery-img" />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hostel;
